import { render, staticRenderFns } from "./PermissaoResourceReview.vue?vue&type=template&id=5bb20295&scoped=true&"
import script from "./PermissaoResourceReview.vue?vue&type=script&lang=js&"
export * from "./PermissaoResourceReview.vue?vue&type=script&lang=js&"
import style0 from "./PermissaoResourceReview.vue?vue&type=style&index=0&id=5bb20295&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb20295",
  null
  
)

export default component.exports